import styled from "styled-components"
import { Container, Grid } from "@mui/material"
import CustomImage from "../../components/custom-image/custom-image.component"

export const Background = styled(Container)`
  background-color: #ffffff;

  ${({ theme }) => theme.breakpoints.up("sm")} {
    padding: 2em 4em 4em;
  }
`

export const Title = styled.h2`
  text-align: center;
  color: ${({ theme }) => theme.palette.tertiary.main};
  font-size: ${({ theme }) => theme.typography.pxToRem(32)};
  line: ${({ theme }) => theme.typography.pxToRem(32)};
`

export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Text = styled.p`
  text-align: center;
  font-size: ${({ theme }) => theme.typography.pxToRem(18)};
`

export const Dash = styled.div`
  height: 1px;
  width: 44%;
  background-color: rgba(25, 27, 29, 0.25);
`

export const GridContainer = styled(Grid)`
  padding-top: 2em;
  padding-bottom: 10em;
`

export const Image = styled(CustomImage)`
  img {
    height: auto;
    width: 100%;
  }
`
